"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render(_c, _vm) {
  return _c('div', {
    staticClass: "app-messagelist-message app-messagelist-message--modern",
    class: [_vm.props.m().isRepeat() ? 'app-messagelist-message--authorrepeat' : 'app-messagelist-message--authorfirst', `app-messagelist-message-${_vm.props.message.type}`, _vm.props.message.type_extra ? `app-messagelist-message-${_vm.props.message.type}-${_vm.props.message.type_extra}` : '', _vm.props.ml.isMessageHighlight(_vm.props.message) ? 'app-messagelist-message--highlight' : '', _vm.props.ml.isHoveringOverMessage(_vm.props.message) ? 'app-messagelist-message--hover' : '', _vm.props.ml.buffer.last_read && _vm.props.message.time > _vm.props.ml.buffer.last_read ? 'app-messagelist-message--unread' : '', _vm.props.message.nick.toLowerCase() === _vm.props.ml.ourNick.toLowerCase() ? 'app-messagelist-message--own' : '', _vm.props.ml.message_info_open === _vm.props.message ? 'app-messagelist-message--info-open' : '', _vm.props.ml.message_info_open && _vm.props.ml.message_info_open !== _vm.props.message ? 'app-messagelist-message--blur' : '', _vm.props.message.user && _vm.props.m().userMode(_vm.props.message.user) ? `app-messagelist-message--user-mode-${_vm.props.m().userMode(_vm.props.message.user)}` : '', _vm.props.message.user && _vm.props.m().userSexClass(_vm.props.message.user) ? `app-messagelist-message--sex-${_vm.props.m().userSexClass(_vm.props.message.user)}` : '', _vm.data.staticClass],
    attrs: {
      "data-message-id": _vm.props.message.id,
      "data-nick": (_vm.props.message.nick || '').toLowerCase()
    },
    on: {
      "click": function ($event) {
        return _vm.props.ml.onMessageClick($event, _vm.props.message, true);
      },
      "dblclick": function ($event) {
        return _vm.props.ml.onMessageDblClick($event, _vm.props.message);
      }
    }
  }, [_c('div', {
    staticClass: "app-messagelist-modern-left"
  }, [_vm.props.m().displayAvatar(_vm.props.message) && _vm.props.message.user ? [_c(_vm.injections.components.UserAvatar, {
    tag: "component",
    attrs: {
      "data-nick": _vm.props.message.nick,
      "user": _vm.props.message.user,
      "network": _vm.props.m().getNetwork(),
      "buffer": _vm.props.ml.buffer,
      "message": _vm.props.message
    }
  })] : _vm.props.message.nick === 'Information système' ? _c('div', {
    staticClass: "app-avatar app-messagelist-sysinfo-avatar"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()], 2), _c('div', {
    staticClass: "app-messagelist-modern-right"
  }, [_c('div', {
    staticClass: "app-messagelist-top"
  }, [_vm.props.message.nick ? _c('a', {
    class: ['app-messagelist-nick', _vm.props.message.user && _vm.props.m().userMode(_vm.props.message.user) ? `app-messagelist-nick--mode-${_vm.props.m().userMode(_vm.props.message.user)}` : ''],
    style: {
      color: _vm.props.ml.userColour(_vm.props.message.user)
    },
    attrs: {
      "data-nick": _vm.props.message.nick.toLowerCase()
    },
    on: {
      "mouseover": function ($event) {
        _vm.props.ml.hover_nick = _vm.props.message.nick.toLowerCase();
      },
      "mouseout": function ($event) {
        _vm.props.ml.hover_nick = '';
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.props.ml.displayNick(_vm.props.message)) + " ")]) : _vm._e(), _vm.props.message.user && _vm.props.m().modeBadge(_vm.props.message.user) ? _c('span', {
    class: `app-mode-badge app-mode-badge--${_vm.props.m().modeBadge(_vm.props.message.user).key}`
  }, [_vm._v(_vm._s(_vm.props.m().modeBadge(_vm.props.message.user).label))]) : _vm._e(), _vm.props.message.nick && _vm.props.message.nick.toLowerCase() === _vm.props.ml.ourNick.toLowerCase() ? _c('span', {
    staticClass: "app-messagelist-you-badge"
  }, [_vm._v("VOUS")]) : _vm._e(), _vm.props.m().showRealName() ? _c('div', {
    staticClass: "app-messagelist-realname",
    on: {
      "click": function ($event) {
        return _vm.props.ml.openUserBox(_vm.props.message.nick);
      },
      "mouseover": function ($event) {
        _vm.props.ml.hover_nick = _vm.props.message.nick.toLowerCase();
      },
      "mouseout": function ($event) {
        _vm.props.ml.hover_nick = '';
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.props.message.user.realname) + " ")]) : _vm._e(), _vm.props.m().isMessage(_vm.props.message) && _vm.props.ml.bufferSetting('show_timestamps') ? _c('div', {
    staticClass: "app-messagelist-time",
    attrs: {
      "title": _vm.props.ml.formatTimeFull(_vm.props.message.time)
    }
  }, [_vm._v(" " + _vm._s(_vm.props.ml.formatTime(_vm.props.message.time)) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "app-messagelist-body-wrapper"
  }, [_vm.props.message.bodyTemplate && _vm.props.message.bodyTemplate.$el && _vm.props.ml.isTemplateVue(_vm.props.message.bodyTemplate) ? _c('div', {
    directives: [{
      name: "rawElement",
      rawName: "v-rawElement",
      value: _vm.props.message.bodyTemplate.$el,
      expression: "props.message.bodyTemplate.$el"
    }],
    staticClass: "app-messagelist-body"
  }) : _vm.props.message.bodyTemplate ? _c(_vm.props.message.bodyTemplate, _vm._b({
    tag: "component",
    staticClass: "app-messagelist-body",
    attrs: {
      "buffer": _vm.props.ml.buffer,
      "message": _vm.props.message,
      "idx": _vm.props.idx,
      "ml": _vm.props.ml
    }
  }, 'component', _vm.props.message.bodyTemplateProps, false)) : _c('div', {
    staticClass: "app-messagelist-body",
    domProps: {
      "innerHTML": _vm._s(_vm.props.ml.formatMessage(_vm.props.message))
    }
  }), _vm.props.message.user && _vm.props.m().isMessage(_vm.props.message) && _vm.props.message.nick.toLowerCase() !== _vm.props.ml.ourNick.toLowerCase() ? _c('a', {
    staticClass: "app-messagelist-report",
    attrs: {
      "title": "Signaler"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.props.ml.reportMessage(_vm.props.message);
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"
    }
  }), _c('line', {
    attrs: {
      "x1": "4",
      "y1": "22",
      "x2": "4",
      "y2": "15"
    }
  })])]) : _vm._e()], 1), _vm.props.ml.message_info_open === _vm.props.message ? _c(_vm.injections.components.MessageInfo, {
    tag: "component",
    attrs: {
      "message": _vm.props.message,
      "buffer": _vm.props.ml.buffer
    },
    on: {
      "close": function ($event) {
        return _vm.props.ml.toggleMessageInfo();
      }
    }
  }) : _vm._e(), _vm.props.message.embed.payload && (_vm.props.ml.shouldAutoEmbed || _vm.props.message.embed.force) ? _c('div', [_c(_vm.injections.components.MediaViewer, {
    tag: "component",
    attrs: {
      "url": _vm.props.message.embed.payload,
      "is-iframe": _vm.props.message.embed.type === 'iframe',
      "show-pin": true
    },
    on: {
      "close": function ($event) {
        _vm.props.message.embed.payload = '';
      },
      "pin": function ($event) {
        return _vm.props.ml.openEmbedInPreview(_vm.props.message);
      }
    }
  })], 1) : _vm._e()], 1)]);
};
var staticRenderFns = exports.staticRenderFns = [];